/** Coming up's standard look (signed-in-home.html Band 4 .b4Up, .b4Foot). */
import { useId } from 'react';

import { partsOf, pieceRoot } from '../../contract/runtime';
import account from '../../styles/account.module.css';
import { Icon } from '../../ui/Icon';
import { onLink } from '../../ui/onLink';
import css from './ComingUp.module.css';
import type { ComingUpRuntime } from './useComingUp';
import { contract } from './contract';

const part = partsOf(contract);

export function ComingUpView({ state, actions }: ComingUpRuntime) {
  const headingId = useId();
  if (state.bookings.length === 0) return null;
  return (
    <section className={account.sec} aria-labelledby={headingId} {...pieceRoot(contract)} {...part('section')}>
      <div className={account.label}>
        <div className={account.eyebrow} id={headingId} {...part('heading')}>
          Coming up
        </div>
      </div>
      <ul className={css.rows}>
        {state.bookings.map((b) => (
          <li key={b.id} className={css.row} {...part('booking')}>
            <span className={css.date} aria-label={b.dateLabel}>
              <span className={css.mon}>{b.month}</span>
              <span className={css.day}>{b.day}</span>
            </span>
            <span className={css.svc}>{b.name}</span>
            <span className={css.when}>{b.when}</span>
            <span>{b.where}</span>
            <span className={account.status}>{b.status}</span>
            <a className={`${account.act} ${css.view}`} href={b.href} onClick={onLink(() => actions.open(b.href))} aria-label={`View ${b.name}`} {...part('view')}>
              View
            </a>
          </li>
        ))}
      </ul>
      <div className={css.foot}>
        <p className={account.quiet} {...part('total')}>
          {state.total}
        </p>
        <a className={account.act} href={state.allHref} onClick={onLink(() => actions.open(state.allHref))} {...part('viewAll')}>
          View all bookings
          <Icon name="arrow" small />
        </a>
      </div>
    </section>
  );
}
